var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcPdfFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.14982 0H14.1738L20.9744 7.08846V20.8756C20.9744 22.6027 19.5771 24 17.8559 24H6.14982C4.42269 24 3.02539 22.6027 3.02539 20.8756V3.12443C3.02536 1.3973 4.42266 0 6.14982 0Z",
    fill: "#E5252A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.302,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.168 0V7.03449H20.9746L14.168 0Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.49756 17.907V13.5232H8.36263C8.8244 13.5232 9.19023 13.6491 9.46609 13.907C9.74195 14.1589 9.87989 14.5007 9.87989 14.9265C9.87989 15.3523 9.74195 15.6941 9.46609 15.946C9.19023 16.2039 8.8244 16.3298 8.36263 16.3298H7.619V17.907H6.49756ZM7.619 15.3763H8.2367C8.4046 15.3763 8.53654 15.3403 8.62651 15.2564C8.71645 15.1784 8.76445 15.0704 8.76445 14.9265C8.76445 14.7826 8.71648 14.6747 8.62651 14.5967C8.53657 14.5127 8.40463 14.4768 8.2367 14.4768H7.619V15.3763ZM10.3416 17.907V13.5232H11.8949C12.2007 13.5232 12.4886 13.5652 12.7584 13.6551C13.0283 13.7451 13.2742 13.871 13.49 14.0449C13.706 14.2129 13.8799 14.4407 14.0058 14.7286C14.1257 15.0165 14.1917 15.3463 14.1917 15.7181C14.1917 16.0839 14.1258 16.4138 14.0058 16.7016C13.8799 16.9895 13.706 17.2173 13.49 17.3852C13.2741 17.5592 13.0283 17.6851 12.7584 17.7751C12.4886 17.865 12.2007 17.907 11.8949 17.907H10.3416ZM11.4391 16.9535H11.7629C11.9368 16.9535 12.0988 16.9355 12.2487 16.8935C12.3926 16.8515 12.5305 16.7856 12.6625 16.6956C12.7884 16.6057 12.8904 16.4797 12.9623 16.3118C13.0343 16.1439 13.0703 15.946 13.0703 15.7181C13.0703 15.4842 13.0343 15.2863 12.9623 15.1184C12.8904 14.9505 12.7884 14.8246 12.6625 14.7346C12.5305 14.6447 12.3926 14.5787 12.2487 14.5367C12.0988 14.4947 11.9368 14.4767 11.7629 14.4767H11.4391V16.9535ZM14.7554 17.907V13.5232H17.8739V14.4767H15.8769V15.1784H17.4721V16.1259H15.8769V17.907H14.7554Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPdfFile);
export default __webpack_public_path__ + "static/media/ic-pdf-file.78ba0d7291f671a3d8a539bb2eea5e99.svg";
export { ForwardRef as ReactComponent };